import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {User} from "../../../models/user";
import {UserService} from "../../../services/user/user.service";
import {BaseComponent} from "../../base/base.component";
import {Invoice} from "../../../models/invoice";
import {TableComponent} from "../../ui/table/table.component";
import {AgentService} from "../../../services/agent/agent.service";
import Swal, {SweetAlertResult} from "sweetalert2";
import {InvoiceService} from "../../../services/invoice/invoice.service";

@Component({
    selector: 'app-agent-details',
    templateUrl: './agent-details.component.html',
    styleUrls: ['./agent-details.component.scss']
})
export class AgentDetailsComponent extends BaseComponent implements OnInit {

    @ViewChild('invoicesTable') invoicesTable: TableComponent | undefined;

    agentId: string = '';
    agent: User = new User();

    componentIndex: number = 1;

    constructor(public route: ActivatedRoute,
                public userService: UserService,
                private agentService: AgentService,
                private invoiceService: InvoiceService,
                public serviceInjector: Injector) {
        super(serviceInjector);
    }

    async ngOnInit() {
        this.showSpinner();
        this.agentId = this.route.snapshot.params['agentId'];
        this.agent = await this.userService.getAgent(this.agentId);
        this.hideSpinner();
    }

    showComponent(component: number) {
        this.componentIndex = component;
        if (component === 4) {
            setTimeout( async () => {
            this.showSpinner();
                await this.invoicesTable?.loadData('/invoices', {
                    agentId: this.agentId
                }, (item: any) => new Invoice(item));
            this.hideSpinner();
            }, 1)
        }
    }

    async updateAgent(){
        this.showSpinner();
        const agentUpdated = await this.userService.updateUser(this.agent);
        this.hideSpinner();

        if (agentUpdated) {
            this.showSuccessMessage('Agente aggiornato');
        } else {
            this.showErrorMessage('Errore nell\'aggiornamento dell\'agente');
        }
    }

    async updateProfilePicture(event: any) {
        this.showSpinner();
        try {
            const profileImg = event?.target?.files[0];

            if (!profileImg) return;

            const formData = new FormData();
            formData.append('file', profileImg);

            const response: any = await this.agentService.upload(formData)

            if (response.success) {
                this.showSuccessMessage('Immagine caricata con successo');
                this.agent.image = response.data;
            } else {
                this.showErrorMessage('Errore, riprova a caricare l\'immagine');
            }
        } catch (e) {
            this.showErrorMessage('Errore, riprova a caricare l\'immagine');
        }
        this.hideSpinner();
    }

    removeProfileImage() {
        this.agent.image = '';
    }

    async updateDocumentFront(event: Event) {
        await this.uploadIdentityDocument(event, 'front');
    }

    async updateDocumentBack(event: Event) {
        await this.uploadIdentityDocument(event, 'back');
    }

    removeDocumentFront() {
        this.agent.documentUrlFront = '';
    }

    removeDocumentBack() {
        this.agent.documentUrlBack = '';
    }

    private async uploadIdentityDocument(event: Event, side: 'front' | 'back') {
        const file = (event.target as HTMLInputElement)?.files?.[0];
        if (!file) return;

        this.showSpinner();
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response: any = await this.userService.uploadUser(formData);

            if (response?.success) {
                if (side === 'front') {
                    this.agent.documentUrlFront = response.data;
                } else {
                    this.agent.documentUrlBack = response.data;
                }
                this.showSuccessMessage('Documento caricato con successo');
            } else {
                this.showErrorMessage('Errore nel caricamento del documento');
            }
        } catch {
            this.showErrorMessage('Errore nel caricamento del documento');
        }
        this.hideSpinner();
    }

    disableAgent(agentId: string) {
        this.showSpinner();
        this.agentService.reject(agentId).subscribe( (response: any) => {
            if (response.success) {
                this.showSuccessMessage('Agente rifiutato!');
                this.goTo('/admins/agents')
            } else {
                this.showErrorMessage('Errore, impossibile rifiutare l\'agente')
            }
        });
        this.hideSpinner();
    }

    async markAsPaid(invoiceId: string) {
        Swal.fire({
            icon: "warning",
            title: "Vuoi veramente segnare la fattura come pagata?",
            showCancelButton: true,
            cancelButtonText: "Annulla operazione"
        })
            .then(async (res: SweetAlertResult) => {
                if (res.isConfirmed) {
                    this.showSpinner();
                    let result = await this.invoiceService.markAsPaid(invoiceId)
                    if (result.success) {
                        this.showSuccessMessage("Fattura segnata come pagata!")
                        this.invoicesTable?.reloadPage();
                    } else {
                        this.showErrorMessage("Errore nell'operazione, riprova")
                    }
                    this.hideSpinner();
                }
            })
    }
}
